import styled from "styled-components";

const Container = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    /* max-width: 500px; */
    // height: calc(100% - 70px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export {
    Container
}